import React, { Component } from 'react';
import PropTypes from 'prop-types'
import queryString from 'query-string';
import Helmet from 'react-helmet'
import Header from '../components/header'
import Steps from '../components/steps'


import './index.css'

import RoiCalculator from '../components/RoiCalculator';

let windowGlobal = typeof window !== 'undefined' && window;

class Layout extends Component {
  
  constructor(props) {
    super(props);
    
    if (typeof window !== `undefined`) {
     var sessinData = JSON.parse(window.sessionStorage.getItem('roiData'));
    }else{
      var sessinData =  {}
    }
    
    var fPreviewObject = {};
    var locationSearch = this.props.history.location.search;
    if(locationSearch.indexOf("preview") != -1 ){
      fPreviewObject = {previewlinkObject : queryString.parse(locationSearch)}
    }

    let defaultData  = {

      
      "/":true,
      "funnel":false,
      "revenue-ltv":false,
      "investment":false,
      "result":false,
      enLeadsPM: "",//441, // lets suppose  or user can modify it accordingly 
      enMonthlyVisitors: "", //41000, // lets suppose  or user can modify it accordingly 
      visConverRate: 0,
      visConverRate_r:0,

      // step 3
      enACV: 20000, // lets suppose  or user can modify it accordingly 
      enAvgSubcriptionlength: 5, // lets suppose  or user can modify it accordingly 
      enGrossMarginPct: 75, // lets suppose  or user can modify it accordingly 

      enOnsiteOptimization: 40, // lets suppose  or user can modify it accordingly 
      enMQLOptimization: 60, // lets suppose  or user can modify it accordingly 
      enOppOptimization: 80, // lets suppose  or user can modify it accordingly 

      enAnnualInvestment: 100000, // lets investment would be or User needs to enter
      enDiscountRate: 9, // let discount rate would be

      enLead_MQL: 28, // 0.28, // lets suppose  or user can modify it accordingly 
      enMQL_opp: 13, // 0.13, // lets suppose  or user can modify it accordingly 
      enOpp_CW:16, // 0.16, // lets suppose  or user can modify it accordingly 

      outVolMQL: null,
      outVolMQL_r: null,
      outVolOPP: null,
      outVolOPP_r: null,
      outVolCW: null,
      outVolCW_r: null,

      outAvgLeadValue: null,
      outAvgLeadValue_r: null,
      outAvgMQLvalue: null,
      outAvgMQLvalue_r: null,
      outAvgOppValue: null,
      outAvgOppValue_r: null,

      outOPPpm: null,
      outOPPpm_r: null,
      outCWpm: null,
      outCWpm_r: null,

      LTV: null,

      ABvariationPerYear: 24, // lets suppose  or user can modify it accordingly 
      PROvariationPerYear: 48, // lets suppose  or user can modify it accordingly 

      ABwinningVariation: null,
      PROwinningVariation: null,
      ABtotalLift: null,
      PROtotalLift: null,

      ABwinningPCT: 15,
      PROwinningPCT: 70,

      abLift: 10,
      proLift: 10,
      loopEnCRImprovement: 0.2,
      onSiteRoIArr: [],
      MQLRoIArr: [],
      oPPRoIArr: [],
      scenerioROI_AB:null,
      scenerioROI_PRO_Onsite:null,
      scenerioROI_PRO_MQL:null,
      scenerioROI_PRO_OPP:null,
      graphData:"",
      allowed: [
        'enLeadsPM',
        'enMonthlyVisitors',
        'enLead_MQL',
        'enMQL_opp',
        'enOpp_CW',
        'enACV',
        'enAvgSubcriptionlength',
        'enGrossMarginPct',
        'enAnnualInvestment',
        'ABvariationPerYear',
        'PROvariationPerYear',
        'enOnsiteOptimization', 
        'enMQLOptimization',
        'enOppOptimization'

    ], 
    previewlinkObject : ""

    }


    let defaultState =   sessinData ?{...sessinData} : { ...this.props ,  ...defaultData ,  ...fPreviewObject, ...(fPreviewObject.previewlinkObject)};
    
    let calculateState =  RoiCalculator(defaultState);

    this.state = calculateState;

    this.updateValue = this.updateValue.bind(this);
    this._enOppOptimization = this._enOppOptimization.bind(this);
    this._enMQLOptimization = this._enMQLOptimization.bind(this);
    this._enOnsiteOptimization = this._enOnsiteOptimization.bind(this);

  }

  componentDidMount() {
    this.setState(this.state);
  }
  
  _enOnsiteOptimization(value) {

    let data = this.state;

    if(data['enMQLOptimization'] < data['enOnsiteOptimization'] ){
      data['enMQLOptimization'] = value;
    }

    if(data['enOppOptimization'] < data['enOnsiteOptimization'] ){
      data['enOppOptimization'] = value;
    }

    
    data['enOnsiteOptimization'] = value;
    data = RoiCalculator(data);
    this.setState(prevState => ({...data}));

  }

 


  _enMQLOptimization(value) {
    
    let data = this.state;

    if(data['enMQLOptimization'] < data['enOnsiteOptimization'] ){
      data['enOnsiteOptimization'] = value;
    }


    if(data['enOppOptimization'] < data['enMQLOptimization'] ){
      data['enOppOptimization'] = value;
    }


    data['enMQLOptimization'] = value;
    data = RoiCalculator(data);
    this.setState(prevState => ({...data}));
    
  }

  _enOppOptimization(value) {
    
    let data = this.state;

    if(data['enOppOptimization'] < data['enMQLOptimization'] ){
      data['enMQLOptimization'] = value;
    }
    if(data['enOppOptimization'] < data['enOnsiteOptimization'] ){
      data['enOnsiteOptimization'] = value;
    }

    data['enOppOptimization'] = value;
    data = RoiCalculator(data);
    this.setState(prevState => ({...data}));

  }

  

  

  updateValue(value , e) {
    
    if(!e){
      e = value;
    }

    let key = e.target.getAttribute('data-rel');
    let data = this.state;
    if(e.target.getAttribute('data-max')){
      if(value.value <= 101){
        data[key] = value.value;
      }
    }else{
      data[key] = value.value;
    };

    

    
    data = RoiCalculator(data);

    if(value.value =="" ){
      e.target.classList.add('feError');
    }else{
      e.target.classList.remove('feError');
    }

    this.setState(prevState => ({...data}));

  }

  componentDidMount(){

    //checkRedirect(this.state);

  }
  render() {

    return (
      <div className="Fe_main_section">
        <Helmet
          title={this.props.data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'See how Predictive Revenue Optimization can deliver marketing ROI over testing and personalization' },
            { name: 'keywords', content: 'b2b, marketing, optimization, a/b testing, personalization' }
          ]}
        />
        <Header  siteTitle={this.props.data.site.siteMetadata.title} />
        
        <Steps siteProps={this.state} />

        <div className="midd_section">
         {this.props.children({ ...this.props,
           data: this.state, 
           updateValue: this.updateValue ,
            _enOnsiteOptimization:this._enOnsiteOptimization ,
             _enMQLOptimization:this._enMQLOptimization,
              _enOppOptimization:this._enOppOptimization})}
        </div>
      </div>
    );
  }
}



Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js